/**
 * 约看 接口的统一出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/c-api/'

const index = {
  // 首页
  index (params) {
    return axios.get('/home/live/index', { params: params })
  },
  // 约看
  detail (params) {
    return axios.get('/home/live/detail', { params: params })
  },
  // 购票详情
  bookeSpecs (params) {
    return axios.get('/home/live/specs', { params: params })
  },
  // 4.订票
  createorder (params) {
    return axios.post('/home/live/order', qs.stringify(params))
  },
  // 5.约看订单
  liveorderlist (params) {
    return axios.get('/home/liveorder/list', { params: params })
  },
  // 6.约看支付
  livePay (params) {
    return axios.post('/home/live/topay', qs.stringify(params))
  },
  // 取消订单
  cancelLive(params){
	return axios.post('/home/live/cancel', qs.stringify(params))
  },
  // 订单详情
  orderDetail(params){
	return axios.get('/home/liveorder/detail', { params: params })
  },
  // 验证门票是否可以核销
  verfyOrder(params){
	return axios.post('/home/liveorder/verfy', qs.stringify(params))
  },
  // 核销
  wirteoffOrder(params){
	return axios.post('/home/liveorder/wirteoff', qs.stringify(params))
  }
}

// 导出接口
export default index
